import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=ac1021d4&scoped=true&"
import script from "./EpsCard.js?vue&type=script&lang=js&"
export * from "./EpsCard.js?vue&type=script&lang=js&"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=ac1021d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1021d4",
  null
  
)

export default component.exports